import { axiosInstance } from './rest';

export function listApiKeys() {
  return axiosInstance.get('/api/v2/users/me/apiKeys');
}

export function createApiKey(apiKey) {
  return axiosInstance.post('/api/v2/users/me/apiKeys', apiKey);
}

export function revokeApiKey(apiKeyId) {
  return axiosInstance.delete(`/api/v2/users/me/apiKeys/${apiKeyId}`);
}
